import { render, staticRenderFns } from "./fichadadosbiografico.vue?vue&type=template&id=b3c17f52&"
import script from "./fichadadosbiografico.vue?vue&type=script&lang=js&"
export * from "./fichadadosbiografico.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports